import AccountService, {AccountServicesByServiceId, HasActiveAccountServicesByServiceId} from "./AccountService"

export default interface Service {
  ServiceID: number
  ServiceName: string
  ServiceDescription: string
  ServiceCode: string
  SampleType?: string
  ServiceTypeID: number
  DOT: boolean
  ActiveWorkForce: boolean
  ActivateAll: boolean
  Marketplace: boolean
  DisplayOrder: number
  FFServiceCode: string
  MPSku: string
}

export enum ServiceCode {
  DrugDOT = "DOTU",
  Drug = "NDOTU",
  AlcoholBreath = "BALC",
  AlcoholSaliva = "SALC",
  AlcoholBreathDOT = "DOTBALC",
  AlcoholSalivaDOT = "DOTSALC",
  PhysicalDOT = "DOTPHY",
  Physical = "FFPPE",
  POCT = "IDRUG",
  FLEX = "FLEX",
  Audiogram = "AUDIOGRAM",
  Clinical = "CLINICAL",
  COVID = "COVID",
  Pulmonary = "PULMONARY",
  RespiratorFit = "RESPIRATOR",
  RespiratorMedical = "RESPMEQ",
  Tuberculosis = "TBSKIN",
  Wellness = "WELLNESS",
  DOTOral = "DOTO",
  NonDOTOral = "SDRG",
  None = "",
}

let emptyService = {
  ServiceID: 0,
  ServiceName: "",
  ServiceDescription: "",
  ServiceCode: "",
  SampleType: "",
  ServiceTypeID: 0,
  DOT: false,
  ActiveWorkForce: false,
  ActivateAll: false,
  Marketplace: false,
  DisplayOrder: 0,
  FFServiceCode: "",
  MPSku: ""
}

export function ServiceById(items: Service[], serviceId: number) { return  items.find(item => item.ServiceID === serviceId) || emptyService }

export function ServiceByCode(items: Service[], code: ServiceCode): Service  {
  for (let i = 0; i < items.length; i++) {
    if (items[i].FFServiceCode === code) {
      return items[i];
    }
  }
  return emptyService;
}

export function ServicesByServiceTypeId(items: Service[], serviceTypeId: number) { return items.filter(item => item.ServiceTypeID === serviceTypeId) }

export function ServicesByServiceSampleType(items: Service[], sampleType: string): Service[] {
  let result = []
  for (let i = 0; i < items.length; i++) {
    if (items[i].SampleType === sampleType) {
      result.push(items[i])
    }
  }
  return result
}

export function AccountsForServices(services: Service[], accountServices: AccountService[]): AccountService[] {
  let result = []
  for (let i = 0; i < services.length; i++) {
      let accounts = AccountServicesByServiceId(accountServices, services[i].ServiceID);
      for (let j = 0; j < accounts.length; j++) {
        result.push(accounts[j])
      }
  }
  return result
}

export function IsServiceActive(service: Service,  accountServices: AccountService[]): boolean{
  if (!service.ActiveWorkForce) {
    return false
  }
  let result = HasActiveAccountServicesByServiceId(accountServices, service.ServiceID)
  return result
}

export function IsServiceDrug(data: Service): boolean {
  if (data.FFServiceCode === ServiceCode.Drug) {
    return true
  }
  if (data.FFServiceCode === ServiceCode.DrugDOT) {
    return true
  }
  return false
}

export function IsServiceDrugDOT(data: Service): boolean {
  if (!data.DOT) {
    return false
  }
  if (!IsServiceDrug(data)) {
    return false
  }
  return true
}

export function IsServiceDrugNonDOT(data: Service): boolean {
  if (data.DOT) {
    return false
  }
  if (!IsServiceDrug(data)) {
    return false
  }
  return true
}

export function IsServicePOCT(data: Service): boolean {
  if (data.FFServiceCode === ServiceCode.POCT) {
    return true
  }
  return false
}

export function IsServiceFLEX(data: Service): boolean {
  return data.FFServiceCode === ServiceCode.FLEX
}

export function IsServiceCodeTypeDrug(code: ServiceCode): boolean {
  if (code === ServiceCode.Drug) {
    return true
  }
  if (code === ServiceCode.DrugDOT) {
    return true
  }
  if (code === ServiceCode.POCT || code === ServiceCode.FLEX) {
    return true
  }
  return false
}

export function IsServiceCodePOCT(code: ServiceCode): boolean {
  if (code === ServiceCode.POCT ) {
    return true
  }
  return false
}

export function IsServiceCodeFLEX(code: ServiceCode): boolean {
  return code === ServiceCode.FLEX
}

export function IsServiceCodeWellness(code: ServiceCode): boolean {
  return code === ServiceCode.Wellness
}


export function IsServiceCodeCHSBL(code: ServiceCode | string): boolean {
  return code === ServiceCode.Clinical
}
